module.exports = __webpack_public_path__ + "img/avatar-72.b183f9a1.png";